
import { Notification } from "element-ui"; // element-ui的通知（Notification）


// 可关闭式通知提示，titlePara为标题，messagePara为通知内容
    function notificationInfo(titlePara, messagePara, type) {
        let obj = {
        title: titlePara,
        message: `${messagePara}`
        };
        if (type) {
        obj.type = type;
        }
        Notification(obj);
    }




let utils = {
    notificationInfo,
}

export default utils;